<template lang="pug">
	.publisher-logo
		.logo-image
</template>

<script>

	import Screen from './../../mixins/screen';

	export default {
		name: "AccountButton",
		mixins: [Screen],
		screen: {
			updateOn: []
		},
		data() {
			return {

			}
		}
	}
</script>

<style lang="sass" scoped>

	.publisher-logo
		background: 10px center / auto 100% no-repeat
		width: 300px
		height: 35px
		position: relative

		.logo-image
			position: absolute
			left: 5px
			top: -10px
			background: url("../../../public/img/logo/prvk-white.png") center no-repeat
			background-size: contain
			width: 127px
			height: 61px

</style>

